declare var moment: any;
declare var __gs: any; //Globals.IGlobalSetup;

var dateFormat = 'd/m/Y'; //__gs && __gs.dateFormat || 'd/m/Y';

export function formatDate(value: Date): string {
  return moment(value).format(dateFormat);
}

export function formatDateTime(value: Date): string {
  return (
    formatDate(value) +
    ' ' +
    value.getHours() +
    '.' +
    value.getMinutes() +
    '.' +
    value.getMilliseconds()
  );
}

export function toDate(value: string): Date {
  return moment.utc(value, dateFormat).toDate();
}

export function addHours(date: Date, hours: number): Date {
  return moment(date).add(hours, 'hours').toDate();
}

export function firstDateIsBeforeSecond(
  value1: string,
  value2: string
): boolean {
  var first = moment(value1, dateFormat);
  var second = moment(value2, dateFormat);
  return first.isBefore(second);
}

export function toFormValue(value: any): string {
  return value == null ? '' : value.toString();
}

export function encode(value: string): string {
  return value == null ? null : encodeURIComponent(value);
}

export function isNullOrEmpty(value: string): boolean {
  return value == null || value == '';
}

export function isNullOrWhiteSpace(value: string): boolean {
  return isNullOrEmpty(value) || /^\s*$/.test(value);
}
